import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync, FilterTimePicker } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { subscriptionStatus } from '../../enums/subscriptionStatus';
import {
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../items';

const resultsCount = 15;

class SubscriptionsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { subscriptions: { searchSubscription } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchSubscription({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, api } = this.props;
    const {
      users: { lookupByEmailOrId: lookupUser },
      products: { lookupByNameOrId: lookupMembership }
    } = api;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Subscriptions page'
              documentDescription='Subscriptions page'
            />

            <h2 className='main-page-header'>Subscriptions</h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                subscriptionId,
                membershipId,
                reference,
                status,
                userId,
                afterAt,
                beforeAt
              }, updatedKey) => {
                if (updatedKey !== 'subscriptionId') {
                  return {
                    membershipId,
                    reference,
                    status,
                    userId,
                    afterAt,
                    beforeAt
                  };
                }
                return { subscriptionId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='subscriptionId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='subscriptionId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='membershipId'>
                      Membership
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='membershipId'
                      debounce
                      loadOptions={async inputValue => lookupMembership(inputValue, 'Membership')}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='subscriptionId'>
                      Reference
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='reference'
                      placeholder='Filter by reference'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='userId'>
                      User
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='userId'
                      loadOptions={async inputValue => lookupUser(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='status'>
                      Status
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='status'
                      options={subscriptionStatus}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'subscriptions',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/subscription/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Reference',
                    label: 'Reference'
                  }, {
                    property: 'Text',
                    label: 'Text'
                  }, {
                    property: 'Status',
                    label: 'Status',
                    render: ({ Status }) => <DisplayStatus mapping={subscriptionStatus}>{Status}</DisplayStatus>
                  }, {
                    property: 'Created At (CET)',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Subscriptions = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(SubscriptionsInternal)
));

Subscriptions.requiresLogin = true;
Subscriptions.propTypes = { isLoggedIn: PropTypes.bool };

export default Subscriptions;
